/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $FavoriteCategories = {
    type: 'array',
    contains: {
        type: 'FavoriteCategory',
    },
};